import { Casier, ICasierCDS } from "./Casier";
import { ModeleDeBase } from "./ModeleDeBase";
import { INiveauCDS, Niveau } from "./Niveau";
import { IPavillonCDS, Pavillon } from "./Pavillon";
import { IPeriodeCDS, Periode } from "./Periode";
import { ITypeClienteleCDS, TypeClientele } from "./TypeClientele";

export interface ILocationCDS {
  si_locationcasierid: string;
  si_tps_base: number;
  si_tvq_base: number;
  si_total_base: number;
  si_tariflocation_base: number;
  si_tps: number;
  si_tvq: number;
  si_total: number;
  si_tariflocation: number;
  si_acceptationconditionslocation: boolean;
  si_adressedecourriel: string;
  si_prenomdulocateur: string;
  si_nomdulocateur: string;
  si_CasierSI: ICasierCDS;
  si_NiveauSI: INiveauCDS;
  si_ImmeubleSI: IPavillonCDS;
  si_Periodedelocation: IPeriodeCDS;
  si_Typedeclientele: ITypeClienteleCDS;
}

export class Location extends ModeleDeBase {
  TPSBase: number;
  TVQBase: number;
  totalBase: number;
  tarifBase: number;
  TPS: number;
  TVQ: number;
  total: number;
  tarif: number;
  conditionsUtilisation: boolean;
  adresseCourriel: string;
  prenom: string;
  nom: string;
  casier: Casier;
  pavillon: Pavillon;
  niveau: Niveau;
  periode: Periode;
  typeClientele: TypeClientele;

  constructor(entity: ILocationCDS) {
    super(entity.si_locationcasierid);

    this.TPSBase = entity.si_tps_base;
    this.TVQBase = entity.si_tvq_base;
    this.totalBase = entity.si_total_base;
    this.tarifBase = entity.si_tariflocation_base;
    this.TPS = entity.si_tps;
    this.TVQ = entity.si_tvq;
    this.total = entity.si_total;
    this.tarif = entity.si_tariflocation;
    this.conditionsUtilisation = entity.si_acceptationconditionslocation;
    this.adresseCourriel = entity.si_adressedecourriel;
    this.prenom = entity.si_prenomdulocateur;
    this.nom = entity.si_nomdulocateur;
    this.pavillon = new Pavillon(entity.si_ImmeubleSI);
    this.niveau = new Niveau(entity.si_NiveauSI);
    this.casier = new Casier(entity.si_CasierSI);
    this.periode = new Periode(entity.si_Periodedelocation);
    this.typeClientele = new TypeClientele(entity.si_Typedeclientele);
  }

  serialiser(): ILocationCDS {
    return {
      si_locationcasierid: this.id,
      si_tps_base: this.TPSBase,
      si_tvq_base: this.TVQBase,
      si_total_base: this.totalBase,
      si_tariflocation_base: this.tarifBase,
      si_tps: this.TPS,
      si_tvq: this.TVQ,
      si_total: this.total,
      si_tariflocation: this.tarif,
      si_acceptationconditionslocation: this.conditionsUtilisation,
      si_adressedecourriel: this.adresseCourriel,
      si_prenomdulocateur: this.prenom,
      si_nomdulocateur: this.nom,
      si_ImmeubleSI: this.pavillon.serialiser(),
      si_NiveauSI: this.niveau.serialiser(),
      si_CasierSI: this.casier.serialiser(),
      si_Periodedelocation: this.periode.serialiser(),
      si_Typedeclientele: this.typeClientele.serialiser(),
    };
  }
}

export interface INouvelleLocation {
  si_tps: number;
  si_tvq: number;
  si_total: number | null;
  si_tariflocation: number;
  si_acceptationconditionslocation: boolean;
  si_adressedecourriel: string;
  si_prenomdulocateur: string;
  si_nomdulocateur: string;
  si_identifiant_locateur: string;
  casierId: string;
  pavillonId: string;
  niveauId: string;
  periodeId: string;
  typeClienteleId: string;
}

export interface INouvelleLocationCDS {
  si_tps: number;
  si_tvq: number;
  si_total: number | null;
  si_tariflocation: number;
  si_acceptationconditionslocation: boolean;
  si_adressedecourriel: string;
  si_prenomdulocateur: string;
  si_nomdulocateur: string;
  si_identifiant_locateur: string;
  si_codepostal: string;
  si_jeton: string;
  "si_Typedeclientele@odata.bind"?: string;
  "si_NiveauSI@odata.bind"?: string;
  "si_Periodedelocation@odata.bind"?: string;
  "si_CasierSI@odata.bind"?: string;
  "si_ImmeubleSI@odata.bind"?: string;
}

export class NouvelleLocation extends ModeleDeBase {
  TPS: number;
  TVQ: number;
  total: number | null;
  tarif: number;
  conditionsUtilisation: boolean;
  adresseCourriel: string;
  prenom: string;
  nom: string;
  identifiant: string;
  casierId: string;
  pavillonId: string;
  niveauId: string;
  periodeId: string;
  typeClienteleId: string;
  codePostal: string;
  jeton: string;

  constructor(
    entity: INouvelleLocation,
    codePostal: string = "",
    jeton: string = ""
  ) {
    super("");

    this.TPS = entity.si_tps;
    this.TVQ = entity.si_tvq;
    this.total = entity.si_total;
    this.tarif = entity.si_tariflocation;
    this.conditionsUtilisation = entity.si_acceptationconditionslocation;
    this.adresseCourriel = entity.si_adressedecourriel;
    this.prenom = entity.si_prenomdulocateur;
    this.nom = entity.si_nomdulocateur;
    this.identifiant = entity.si_identifiant_locateur;
    this.casierId = entity.casierId;
    this.pavillonId = entity.pavillonId;
    this.niveauId = entity.niveauId;
    this.periodeId = entity.periodeId;
    this.typeClienteleId = entity.typeClienteleId;
    this.codePostal = codePostal;
    this.jeton = jeton;
  }

  serialiser(): INouvelleLocationCDS {
    return {
      si_tps: this.TPS,
      si_tvq: this.TVQ,
      si_total: this.total,
      si_tariflocation: this.tarif,
      si_acceptationconditionslocation: this.conditionsUtilisation,
      si_adressedecourriel: this.adresseCourriel,
      si_prenomdulocateur: this.prenom,
      si_nomdulocateur: this.nom,
      si_identifiant_locateur: this.identifiant,
      si_codepostal: this.codePostal,
      si_jeton: this.jeton,
      "si_Typedeclientele@odata.bind": `/si_typedeclienteles(${this.typeClienteleId})`,
      "si_NiveauSI@odata.bind": `/si_niveausis(${this.niveauId})`,
      "si_Periodedelocation@odata.bind": `/si_periodedelocations(${this.periodeId})`,
      "si_CasierSI@odata.bind": `/si_casiersis(${this.casierId})`,
      "si_ImmeubleSI@odata.bind": `/si_immeublesis(${this.pavillonId})`,
    };
  }
}
